import { BCMSDate, BrandingStyle } from "@bcm-dev/bcms-vite";
import React from 'react';
import "./styles.css";
/**
 * @function FooterView 
 * @param {OBJECT} props - Default React.Components props OBJECT
 * @returns {React.Component}
 * @example
 * <Page>
 *  <FooterView />
 * </Page>
 */
export default function FooterView(props) {
  const year = BCMSDate.init().format("Y");

  return(
    <BrandingStyle style={{ "backgroundColor": "footer_bg_rxp22" }} className="page-footer">
      <div className="flex-container align-center copyright-footer">
        <p>Copyright &copy;{ year } Beavercreek Marketing. All Rights Reserved.</p>
      </div>
    </BrandingStyle>
  );
}